import { http } from '../helpers/axiosHelper';

export default class ChoiceService {
   async createChoice(body: any) {
      return await http.post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/choice', body).then((response) => {
         return response.data;
      });
   }

   async getChoice(choiceId: Number) {
      return await http
         .get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/choice/' + choiceId)
         .then((response) => {
            if (response.status && response.data) {
               return response.data;
            } else {
               throw Error(`Kon optie niet ophalen`);
            }
         })
         .catch((error) => {
            throw Error(`Kon optie niet ophalen`);
         });
   }

   async updateChoice(choiceId: Number, body: any) {
      return await http.put(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/choice/' + choiceId, body);
   }

   async patchChoice(choiceId: Number, body: any) {
      return await http
         .patch(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/choice/' + choiceId, body)
         .then((response) => {
            if (response.status && response.data) {
               return response.data;
            } else {
               throw Error(`Kon optie niet wijzigen`);
            }
         })
         .catch((error) => {
            throw Error(`Kon optie niet wijzigen`);
         });
   }

   async deleteChoice(choiceId: Number) {
      return await http.delete(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/choice/' + choiceId);
   }

   async getAnswersCount(choiceId: Number) {
      return await http.get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/choice/' + choiceId + '/answers-count').then((response) => {
         return response.data;
      });
   }
}
